export default function sharedCookieDomain(loc) {
    // When we're running on fictiv's domain,
    // we can set cookies at the secondary domain level,
    // otherwise, just set at the current domain.
    return loc.host.indexOf('fictiv.com') > 0 ? '.fictiv.com' : ''
}
